var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* No販売店情報（一覧） */
import React, { useState, useEffect, useCallback } from 'react';
import { render } from 'react-dom';
import axios from '../../axios';
import { handleBrowzerBack } from '../../BrowzerBack';
import NoStoreSearchForm from '../../organisms/NoStoreSearchForm';
import NoStoreList from '../../organisms/NoStoreList';
import LoadingModal from '../../organisms/LoadingModal';
import { useToggle } from '../../hooks/ToggleHooks';
import { no_store_search_params_init } from '../../Const';
var NoStore = function () {
    var _a = useState(no_store_search_params_init), search_params = _a[0], setSearchParams = _a[1]; // 検索パラメータ
    var _b = useToggle(false), is_loading = _b[0], setIsLoading = _b[1];
    var _c = useState([]), stores = _c[0], setStores = _c[1];
    //NOコードリスト
    var _d = useState([]), no_code_list = _d[0], setNoCodeList = _d[1];
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        handleClickSearch();
    }, []);
    /**
     * 検索処理
     * @returns void
     */
    var handleClickSearch = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setIsLoading();
                    return [4 /*yield*/, axios.get('staff/no_store/list/search', {
                            params: search_params,
                        })];
                case 1:
                    response = _a.sent();
                    setStores(response.data.no_store_list);
                    setNoCodeList(response.data.option);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [search_params]);
    /**
     * 検索パラメータ変更
     * @param event React.ChangeEvent<HTMLInputElement | HTMLSelectElement> イベントオブジェクト
     * @returns void
     */
    var handleChangeSearchParams = useCallback(function (event) {
        var _a = event.currentTarget, name = _a.name, value = _a.value;
        setSearchParams(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[name] = value, _a));
        });
    }, [search_params]);
    /**
     * 登録ボタンのイベント
     * @returns void
     */
    var handleClickCreateButton = function () {
        location.href = "" + location.origin + process.env.MIX_MOCK_URL + "/staff/no_store/create";
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "container" },
            React.createElement(NoStoreSearchForm, { search_params: search_params, search_option: no_code_list, handleClickSearch: handleClickSearch, handleChangeSearchParams: handleChangeSearchParams, handleClickCreateButton: handleClickCreateButton }),
            React.createElement(NoStoreList, { no_stores: stores })),
        React.createElement(LoadingModal, { show: is_loading })));
};
if (document.getElementById('no-store-list')) {
    render(React.createElement(NoStore, null), document.getElementById('no-store-list'));
}
